<template>
    <div class="list-base">
        <div>
            <div
                v-for="(listItem, listItemIndex) in listItems"
                :key="listItemIndex"
                class="list-base__item"
                :class="{
                  'list-base__item_active': listItemActive !== null && listItemActive.id === listItem.id,
                  'archive-item': isArchive(listItem)
                }"
                @click="onClickListItem(listItem)"
            >
                <input
                    v-if="isCheckbox"
                    type="checkbox"
                    :value="listItem.name" 
                    v-model="checkedValues"
                    @change="onChangeCheckbox"
                >
                <i
                    v-if="isIconPrev"
                    :class="`${iconPrevClass}`"
                    :style="{'color': `#a7b0bd`}"
                    @click.stop="onClickIconPrev(listItem)"
                >
                </i>
                {{listItem.name || ""}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListBase',
    /**
     * входные данные компонента
     * @property {array} listItems - элементы списка
     * @property {object} listItemActive - активный элемент списка
     * @property {boolean} isCheckbox - условие отображение чекбоксов
     * @property {boolean} isIconPrev - условие отображения иконки
     * @property {string} iconPrevClass - класс для иконки
     */
    props: {
        listItems: {
            type: Array,
            default: () => ([])
        },
        listItemActive: {
            type: Object,
            default: () => (null)
        },
        checked: {
            type: Array,
            default: () => ([])
        },
        isCheckbox: {
            type: Boolean,
            default: false
        },
        isIconPrev: {
            type: Boolean,
            default: false
        },
        iconPrevClass: {
            type: String,
            default: ''
        }
    },
    /**
     * Данные компонента
     * @property {array} checkedValues - выбранные значения
     */
    data: () => ({
        checkedValues: []
    }),
    watch: {
        /**
         * следим за переключением отображения чекбоксов
         */
        isCheckbox: function(value) {
            if(value === false) {
                this.checkedValues = [];
                this.$emit('onChangeCheckbox', this.checkedValues);
            } 
        },
        checked: function(values) {
            this.checkedValues = values;
        }
    },
    methods: {
        /**
         * событие клика по элементу списка
         * @param {object} listItem - элемент списка
         */
        onClickListItem(listItem) {
            this.$emit('onClickListItem', listItem);
        },
        /**
         * событие изменения чекбокса
         */
        onChangeCheckbox() {
            this.$emit('onChangeCheckbox', this.checkedValues);
        },
        /**
         * событие клика по иконке элемента списка
         * @param {object} listItem - элемент списка
         */
        onClickIconPrev(listItem) {
            this.$emit('onClickIconPrev', listItem);
        },

        /**
         *
         * @param item
         * @returns {boolean}
         */
        isArchive(item) {
            const {isActive = false} = item;
            return !isActive;
        }
    }
}
</script>

<style lang="scss" scoped>
    .list-base__item {
        padding: 5px 0 5px 15px;
        cursor: pointer;
    }
    .list-base__item_active {
        background: #f0f0f0;
        padding: 5px 0 5px 15px;
        border-radius: 30px;
    }
    .archive-item {
      color: #ccc;
    }
</style>